import React from 'react'

const UserItem = ({ user = {} }) => <div>
  <span
    className={'users_slider-item-name'}>{user.profile && user.profile.fullName ? user.profile.fullName : user.username}</span>
  <span className={'users_slider-item-id'}>{user.profile && `#${user.profile.employeeNum}`}</span>
</div>

export default UserItem
